"use strict";

var superagent = require("superagent");

var DEFAULT_API_VERSION = "2.0";

function AgendorAPI(apiURL, sessionId) {
  this.apiURL = apiURL;
  this.sessionId = sessionId || getDefaultSessionId();
  this.jwt = getJWT();

  function getDefaultSessionId() {
    return (typeof window !== "undefined" && window.getCookie)?window.getCookie("PHPSESSID"):null;
  }

  function getJWT() {
    return (typeof window !== "undefined" && window.getCookie)?window.getCookie("AGENDOR"):null;
  }
}

AgendorAPI.prototype.validate = function validate(params){
  var validation = true;
  // if (!this.sessionId && !params.sessionId) {
  //   validation = "Session ID is required.";
  // }
  if (!this.apiURL) {
    validation = "API URL not defined.";
  }
  return validation;
};

AgendorAPI.prototype.getURL = function getURL(endpoint){
  return this.apiURL+endpoint;
};

AgendorAPI.prototype.get = function get(endpoint, params, callback, version){
  return this.exec("get", endpoint, params, callback, version);
};

AgendorAPI.prototype.del = function del(endpoint, params, callback, version){
  return this.exec("del", endpoint, params, callback, version);
};

AgendorAPI.prototype.post = function post(endpoint, params, callback, version){
  return this.exec("post", endpoint, params, callback, version);
};

AgendorAPI.prototype.put = function put(endpoint, params, callback, version){
  return this.exec("put", endpoint, params, callback, version);
};

AgendorAPI.prototype.patch = function patch(endpoint, params, callback, version){
  return this.exec("patch", endpoint, params, callback, version);
};

AgendorAPI.prototype.exec = function exec(method, endpoint, params, callback, version){
  var validation = this.validate(params, callback);
  if(validation!=true){
    callback({message:validation}, null);
  } else {
    var params = (method=="get" && params != null)?$.param(params):params;
    var sessionId = this.sessionId || params.sessionId;
    var callback = normalizeCallback(callback);

    var requestOptions = {
      method: method,
      endpoint: this.getURL(endpoint),
      sessionId: sessionId,
      params: params,
      version: version,
      xhrFields: {
        withCredentials: true
      },
      onCompleted: this.handleResponse(endpoint, callback).bind(this)
    };

    return this.request(requestOptions);
  }
};

function normalizeCallback(callback) {
  var callback = callback || {};
  var newCallback = null;

  if (typeof callback === "function") {
    newCallback = {
      success: function(response) {
        callback(response.body, response);
      },
      error: function(err, response) {
        console.error(response, err.stack);
        callback(err, response);
      }
    };
  } else if (typeof callback === "object") {
    if (typeof callback.success !== "function") {
      callback.success = function(response) {
        console.warn("Callback is not a function.");
      };
    }

    if (typeof callback.error !== "function") {
      callback.error = function(response) {
        console.warn("Callback is not a function.");
      };
    }

    newCallback = callback;
  }

  return newCallback;
}

AgendorAPI.prototype.request = function request(options) {
  var sendParamsMethod = (options.method=="get")?"query":"send";
  var apiVersion = (options.version) ? options.version : DEFAULT_API_VERSION;
  var request = superagent[options.method](options.endpoint)
    .set("SESSION_ID",options.sessionId)
    .set("AGENDOR", this.jwt)
    .set("Accept", "application/json")
    .set("VERSION", apiVersion)
    .set("Content-Type", "application/json");

  this.handleUnload(request);

  return request[sendParamsMethod](options.params)
    .withCredentials()
    .end(options.onCompleted);
};

AgendorAPI.prototype.handleResponse = function handleResponse(endpoint, callback) {
  return function(err, response) {
    if (err) {
      this.handleError(err, response, callback);
      return true;
    } else {
      callback.success(response);
      return true;
    }
  };
};

AgendorAPI.prototype.handleUnload = function handleUnload(request) {
  var handler = function() {
    request.abort();
  };

  request.on("end", function() {
    $(window).off("beforeunload", handler);
  });

  $(window).on("beforeunload", handler);
};

AgendorAPI.prototype.handleError = function handleError(err, response, callback) {
  // inicialmente vamos tratar só erro 5xx
  var isServerError = (
    response === undefined || response.status &&
    response.status.toString().match("5..")
  );

  if (isServerError) {
    // 1. dependendo do erro, tentar novamente depois de 1 segundo (https://github.com/segmentio/superagent-retry)
    // 2. se persistir, tentar um HEAD pra um endpoint de outro domínio (AWS?)

    this.checkConnection(function(hasConnection) {
      if (hasConnection) {
        var newError = new Error("Servidor indisponível");
        newError.customError = true;
        newError.clientSideError = false;
        newError.requestAborted = checkRequestHasBeenAborted(err);
        newError.cause = err;

        captureError(newError, { response });

        callback.error(newError, response);
      } else {
        var newError = new Error("Sem conexão com a internet");
        newError.customError = true;
        newError.clientSideError = true;
        newError.requestAborted = false;
        newError.cause = err;

        callback.error(newError, response);
      }
    });

    // 2.1. se o HEAD funcionar, o problema é na nossa API ou no nosso endpoint
    // 2.2. se o HEAD não funcionar, o problema é a conexão do usuário
  } else {
    callback.error(err, response);
  }
};

function checkRequestHasBeenAborted(err) {
  var aborted = false;
  if (err.stack && err.stack.toString()) {
    aborted = err.stack.toString().indexOf(".abort") >= 0 && err.toString().indexOf("timeout of") >= 0;
  }
  return aborted;
}

AgendorAPI.prototype.getResponseHandler = function getResponseHandler(success, error) {
  return function handleResponse(body, response) {
    var undefinedErrorFunction = (typeof error !== "function");
    var successResponse = (
      response && response.status &&
      response.status.toString().match("2..|3..")
    );

    if (undefinedErrorFunction || successResponse) {
      success(body, response);
    } else {
      error(body, response);
    }
  };
};

AgendorAPI.prototype.checkConnection = function checkConnection(callback) {
  var endpointCheck = "https://s3-sa-east-1.amazonaws.com/agendor.com.br/webapp-test-file.html"+
    "?v="+Math.ceil(Math.random() * 10000);

  return jQuery.ajax(endpointCheck, {
    type: "HEAD",
    complete: function(jqXHR) {
      var successResponse = (
        jqXHR && jqXHR.status &&
        jqXHR.status.toString().match("2..|3..")
      );
      callback(successResponse);
    }
  });
};

module.exports = AgendorAPI;



// WEBPACK FOOTER //
// ./app/util/api/api-caller.js